<script lang="ts">
  import type { VenueStateLike } from "./session";
  import VenueClosedBanner from "./VenueClosedBanner.svelte";
  import { panelFreshnessState } from "./panelFreshness";

  interface Props {
    label: string;
    venueState?: VenueStateLike | null;
    stale: boolean;
    ageTitle: string;
  }

  let { label, venueState = null, stale, ageTitle }: Props = $props();
  let state = $derived(panelFreshnessState(venueState?.verdict, stale));
</script>

{#if state === "closed"}
  <VenueClosedBanner venueState={venueState!} />
{:else if state === "stale"}
  <span class="freshness-dot stale" role="status" aria-label={`${label} stale`} title={ageTitle}>●</span>
{:else}
  <span class="freshness-dot live" role="status" aria-label={`${label} live`} title={`${label} live`}>●</span>
{/if}

<style>
  .freshness-dot {
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-left: auto;
    border-radius: 999px;
    color: transparent;
    font-size: 8px;
    line-height: 12px;
    text-align: center;
  }
  .freshness-dot.live { background: var(--up); }
  .freshness-dot.stale {
    background: var(--stale-soft);
    border: 1px solid var(--stale);
    color: var(--stale-ink);
  }
</style>
